"use client";
import Logo from "../logo";
import { NavLink } from "@/data/navLinks";
import Link from "next/link";
import Navigation from "./navigation";
import AtlasThemeToggle from "@/components/AtlasThemeToggle";
import { cn } from "@/lib/cn";
import { usePathname } from "next/navigation";

export default function Navbar({ className }: { className?: string }) {
  const pathname = usePathname();
  const isAtlas = pathname.startsWith("/atlas");
  return (
    <nav
      className={cn(
        "bg-transparent text-grey-900 dark:bg-[#121a29] dark:text-white " +
          "mx-auto flex w-full max-w-5xl items-center justify-between",
        className
      )}
    >
      <Link
        href={`${NavLink.Home}`}
        className={cn(
          "h-[32px] dark:text-white",
          !isAtlas && "dark:bg-white"
        )}
      >
        <Logo />
      </Link>
      <div className="flex items-center gap-4">
        <Navigation />
        <AtlasThemeToggle />
      </div>
    </nav>
  );
}
